import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface RemoveCareMemberParams {
  practitionerId: string;
}

interface RemoveCareMemberResponse {
  careteam: fhirTypes.CareTeam;
}

export const useRemoveCareMember = (patientId: string) => {
  const queryClient = useQueryClient();

  return useApiMutation<RemoveCareMemberResponse, RemoveCareMemberParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chat.CareTeam.REMOVE_MEMBER(patientId),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/clinic/careteam/patient/${patientId}/remove-member`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chat.CareTeam.DEFAULT(patientId),
        });
      },
    },
  });
};
